import { render, staticRenderFns } from "./ImportacaoProduto.vue?vue&type=template&id=5765c26c&"
import script from "./ImportacaoProduto.vue?vue&type=script&lang=js&"
export * from "./ImportacaoProduto.vue?vue&type=script&lang=js&"
import style0 from "./ImportacaoProduto.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports